import React from "react";
import Dashboard from "./Dashboard";
import { useState, useEffect } from "react";
import { useActionData, useLocation } from "react-router-dom";
import UserProfileScreen from "./UserProfileScreen";
import UserWelcomeScreen from "./UserWelcomeScreen";
import UserCalendarScreen from "./UserCalendarScreen";
import UserPatientListScreen from "./UserPatientListScreen";
import UserAccountScreen from "./UserAccountScreen";
import ResourcesScreen from "./ResourcesScreen";
import ProviderSelection from "./ProviderSelection";
import ServiceSelection from "./ServiceSelection";
import BookingScreen from "./BookingScreen";
import MessagingPage from "./MessagingPage";
import "./UserLanding.css";
// This is where the user ends up after logging in, or clicking "Home" in the navbar.
const UserLanding = ({
  selectedSection,
  setSelectedSection,
  setLogin,
  services,
  toggleSidebar,
  isSidebarOpen,
}) => {
  const location = useLocation();
  const { user } = location.state || {};
  const [UserLandingData, setUserLandingData] = useState({
    username: "Guest",
    email: "guest@gmail.com",
  });
  const [selectedPatient, setSelectedPatient] = useState([]);
  const [selectedImg, setSelectedImg] = useState([]);
  const [isMobileWeb, setIsMobileWeb] = useState(false);

  function renderPatientProfile(patient, img) {
    setSelectedImg(img);
    setSelectedPatient(patient);
    setSelectedSection("Profile");
  }

  const renderSection = () => {
    switch (selectedSection) {
      case "Patient":
        return (
          <UserPatientListScreen renderPatientProfile={renderPatientProfile} />
        );
      case "Profile":
        return (
          <UserProfileScreen
            patient={selectedPatient}
            img={selectedImg}
            setSelectedSection={setSelectedSection}
          />
        );
      case "Calendar":
        return <UserCalendarScreen setSelectedSection={setSelectedSection} />;
      case "Account":
        return <UserAccountScreen />;
      case "Messages":
        return <MessagingPage />;
      case "Resources":
        return <ResourcesScreen />;
      case "Provider":
        return <ProviderSelection />;
      case "Services":
        return <ServiceSelection services={services} />;
      case "Booking":
        return <BookingScreen />;
      default:
        return <h1>Not Found</h1>;
    }
  };
  // Get username and email or use guest data.
  useEffect(() => {
    const checkScreenWidth = () => {
      setIsMobileWeb(window.innerWidth <= 1021);
    };
    checkScreenWidth();
    window.addEventListener("resize", checkScreenWidth);
    if (user) {
      setUserLandingData({
        username: user.username || "Guest",
        email: user.email || "No email provided",
      });
    }
    return () => {
      window.removeEventListener("resize", checkScreenWidth);
    };
  }, [user]);

  return (
    <>
      {!isMobileWeb || isSidebarOpen ? (
        <>
          {/* Sidebar */}
          <Dashboard
            UserLandingData={UserLandingData}
            setSelectedSection={setSelectedSection}
            toggleSidebar={toggleSidebar}
            isSidebarOpen={isSidebarOpen}
            isMobileWeb={isMobileWeb}
            setLogin={setLogin}
          />
        </>
      ) : (
        <></>
      )}
      {/* Main Content */}
      <div
        className="userHomeContainer"
        style={{
          display: `${!isMobileWeb || !isSidebarOpen ? "block" : "none"}`,
        }}
      >
        {renderSection()}
      </div>
    </>
  );
};

export default UserLanding;
